import { useState, useEffect } from "react";
import { isMobileDevice } from "@/utils/mobileDetect";

/**
 * Hook to detect mobile devices and handle window resize events
 * @returns boolean indicating if the current device is mobile
 */
export const useMobileDetection = (): boolean => {
  const [isMobile, setIsMobile] = useState<boolean>(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(isMobileDevice());
    };

    // Check on initial load
    checkMobile();

    // Add event listener for window resize
    window.addEventListener("resize", checkMobile);

    // Clean up event listener
    return () => {
      window.removeEventListener("resize", checkMobile);
    };
  }, []);

  return isMobile;
};
